/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectPublishStatusEnum } from './projectPublishStatusEnum';


/**
 * Project publication status
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProjectPublishStatus { 
    publishStatus?: ProjectPublishStatusEnum;

    constructor(item?: Partial<ProjectPublishStatus>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            publishStatus: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.publishStatus : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProjectPublishStatus.isValid,
        };
    }

    static isValid(obj: ProjectPublishStatus): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProjectPublishStatus.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.publishStatus.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

